const feedTemplate = () => `
<div class="swiper swiper--instant-play-games">
    <div class="swiper-wrapper">
    </div>
</div>`

export default feedTemplate
